



















































































import Vue from "vue";
import ShareButtons from "@/components/ShareButtons.vue";
import isMobile from "ismobilejs";

export default Vue.extend({
  components: {
    ShareButtons
  },
  computed: {
    instructions() {
      if (isMobile().any)
        return "Guide your skier with your finger release to jump.";
      return "Guide your skier with your mouse. Use space/click to jump.";
    }
  }
});
